import { supabase } from './supabaseClient';

export type AuditLog = {
  id: string;
  created_at: string;
  user_id: string;
  action: string;
  location_id: string;
  product_id: string;
  quantity: number;
  organization_id: string;
  entity_type: string;
  entity_id: string;
  old_quantity: number;
};

export class AuditLogsClient {
  static async getAuditLogsByOrganizationId(
    organization_id: string
  ): Promise<AuditLog[]> {
    const { data, error } = await supabase
      .from('audit_logs')
      .select('*')
      .eq('organization_id', organization_id)
      .order('created_at', { ascending: false });
    if (error) {
      throw error;
    }
    return data;
  }

  static async createAuditLog(auditLog: AuditLog): Promise<AuditLog> {
    const { data, error } = await supabase
      .from('audit_logs')
      .insert(auditLog)
      .select();
    if (error) {
      throw error;
    }
    return data[0];
  }

  static async updateAuditLog(auditLog: AuditLog): Promise<AuditLog> {
    const { data, error } = await supabase
      .from('audit_logs')
      .update(auditLog)
      .eq('id', auditLog.id)
      .select();
    if (error) {
      throw error;
    }
    return data[0];
  }

  static async deleteAuditLog(id: string): Promise<AuditLog> {
    const { data, error } = await supabase
      .from('audit_logs')
      .delete()
      .eq('id', id)
      .select();
    if (error) {
      throw error;
    }
    return data[0];
  }

  static async getMonthlyAuditLogCountsByOrganizationId(
    organizationId: string,
    timeRange: number = 12
  ) {
    const isDaily = timeRange < 1;
    const { data, error } = await supabase.rpc(
      isDaily ? 'get_daily_audit_log_counts' : 'get_monthly_audit_log_counts',
      {
        org_id: organizationId,
        [isDaily ? 'days' : 'months']: isDaily ? 7 : Math.floor(timeRange),
      }
    );

    if (error) {
      throw error;
    }

    return data || [];
  }

  static async getMonthlyStockMovements(
    organizationId: string,
    timeRange: number
  ) {
    const isDaily = timeRange < 1;
    const { data, error } = await supabase.rpc(
      isDaily ? 'get_daily_stock_movements' : 'get_monthly_stock_movements',
      {
        p_organization_id: organizationId,
        [isDaily ? 'days' : 'months']: isDaily ? 7 : Math.floor(timeRange),
      }
    );

    if (error) {
      throw error;
    }

    return data || [];
  }
}
